var map = {
	"./Corteva_Do_More_with_Less-desktop.jpg": 399,
	"./Corteva_Do_More_with_Less-mobile.jpg": 400,
	"./Corteva_Do_More_with_Less-tablet.jpg": 401,
	"./Corteva_From_Data_to_Decision-desktop.jpg": 402,
	"./Corteva_From_Data_to_Decision-mobile.jpg": 403,
	"./Corteva_From_Data_to_Decision-tablet.jpg": 404,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-desktop.jpg": 405,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-mobile.jpg": 406,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-tablet.jpg": 407,
	"./Farming_where_it_doesnt_rain_tablet.png": 408,
	"./TMT-CORT010-120-desktop.jpg": 409,
	"./TMT-CORT010-120-mobile.jpg": 410,
	"./TMT-CORT010-120-tablet.jpg": 411,
	"./Tanzania-Queen-and-Son-small-desktop.jpg": 412,
	"./Tanzania-Queen-and-Son-small-mobile.jpg": 413,
	"./Tanzania-Queen-and-Son-small-tablet.jpg": 414,
	"./Thailand-desktop.jpg": 415,
	"./Thailand-mobile.jpg": 416,
	"./Thailand-tablet.jpg": 417,
	"./art-of-precision.jpg": 418,
	"./brasil_new_pastures-desktop.jpg": 419,
	"./brasil_new_pastures-mobile.jpg": 420,
	"./brasil_new_pastures-tablet.jpg": 421,
	"./cracking-the-code-desktop.jpg": 422,
	"./cracking-the-code-mobile.jpg": 423,
	"./cracking-the-code-tablet.jpg": 424,
	"./seeds-of-change-desktop.jpg": 425,
	"./seeds-of-change-mobile.jpg": 426,
	"./seeds-of-change-tablet.jpg": 427,
	"./silicon-farm-poster-desktop.jpg": 428,
	"./silicon-farm-poster-mobile.jpg": 429,
	"./silicon-farm-poster-tablet.jpg": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644;